"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenu = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _Icon = require("../Icon");
var _Text = require("../Text");
var _SubMenuModule = _interopRequireDefault(require("./SubMenu.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SubMenu = exports.SubMenu = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    children,
    title,
    titleIcon,
    titleIconSize,
    titleIconType,
    onClose,
    showClose = false,
    testId
  } = _ref;
  const childrenWithProps = React.Children.map(children, child => {
    if (/*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _SubMenuModule.default.menuChildWrap,
        children: /*#__PURE__*/React.cloneElement(child, {})
      });
    }
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classify.default)(_SubMenuModule.default.subMenuWrapper, classNames?.wrapper),
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _SubMenuModule.default.subMenuTitleAndButton,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _SubMenuModule.default.subMenuTitleWrapper,
        children: [!!titleIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          color: _Text.TEXT_COLORS.inverseSecondary,
          name: titleIcon,
          type: titleIconType,
          size: titleIconSize,
          className: _SubMenuModule.default.titleIcon,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'title-icon'
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.SubTitleMedium, {
          className: _SubMenuModule.default.subMenuHeader,
          color: _Text.TEXT_COLORS.inversePrimary,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'title'
          }),
          children: title
        })]
      }), showClose && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        ariaLabel: "Icon Button",
        iconRightName: "close",
        onClick: onClose,
        size: "small",
        type: "ghost",
        actionType: "button",
        classNames: {
          wrapper: _SubMenuModule.default.subMenuCloseButton,
          icon: _SubMenuModule.default.subMenuCloseIcon
        },
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'close-button'
        })
      })]
    }), childrenWithProps]
  });
});
SubMenu.displayName = 'SubMenu';